import { createContext } from 'react';
import type { PriceError } from '@apiTypes';
import type { UserAddress } from '../../user/types';
import type { CheckoutPriceSummary } from '../queries/useCheckoutQuery';
import type {
    Branch,
    CheckoutErrorType,
    CheckoutWarningType,
    ShippingMethod,
} from '../types';

export interface CheckoutFields {
    billingAddress?: UserAddress;
    shippingAddress: UserAddress[];
    branches: Branch[];
    shippingMethods: ShippingMethod[];
    errorCodes: CheckoutErrorType[];
    warnings: CheckoutWarningType[];
    requiresPrepay: boolean;
    isPaymentTermsMutable: boolean;
    checkoutPriceSummary?: CheckoutPriceSummary;
    checkoutPriceSummaryErrors: PriceError[];
}

export interface CheckoutContextValue {
    loading: boolean;
    initialized: boolean;
    checkoutFields: CheckoutFields;
}

const CheckoutContext = createContext<CheckoutContextValue>({
    loading: false,
    initialized: false,
    checkoutFields: {
        billingAddress: undefined,
        shippingAddress: [],
        branches: [],
        shippingMethods: [],
        errorCodes: [],
        requiresPrepay: false,
        isPaymentTermsMutable: false,
        warnings: [],
        checkoutPriceSummaryErrors: [],
    },
});

export default CheckoutContext;
